module.exports = __webpack_public_path__ + "img/magento-support-security.c1195a20.webp";